import React, { Component } from "react";

class ReviewBox extends Component {
  render() {
    const { review, cancelClick } = this.props;
    const fontSize = window.innerWidth > 480?"1.5rem":"12px";
    return (
      <div className="col-lg-6">
        <div className="number">
            <div className="col-xs-2"> <img src={review.logo_path} /></div>
            <div className="col-xs-6 box1">
              <p>{review.game_name}</p>
              <span style={{color: "#747474", lineHeight: "1.5", fontSize: fontSize}}>伺服器：{review.server_name}</span><br />
              <span style={{color: "#747474", lineHeight: "1.5", fontSize: fontSize}}>角色ID：{review.role_id}</span> </div>
            <div className="col-xs-4 success"> <span>審核中</span>
              <button type="button" onClick={(e) => cancelClick(review.idx)}>取消</button>
            </div>
        </div>
      </div>
    );
  }
}

export default ReviewBox;
